import React from 'react';
import { Link } from 'react-router-dom';

// Removed — the floating button was obstructive and annoying on mobile.
// CTA is available in the hero section and at the bottom of every page.
const MobileFloatingCTA: React.FC = () => {
  return null;
};

export default MobileFloatingCTA;
